module.exports = __webpack_public_path__ + "static/media/heyCM.b5137a14.jpg";